module.exports = __webpack_public_path__ + "static/media/pier_cpl_1920-2.973363e9.jpg";